import { getLastUpdateTime } from 'mini-calendar-events-session-storage';

/**
 * This returns stale duration of session events to be used as one of the payload in LCP event
 */
export function getSessionEventsStaleDuration() {
    const lastUpdatedTime = getLastUpdateTime();
    let diffInDuration = -1;
    if (lastUpdatedTime) {
        const lastUpdateTimeInMS = new Date(lastUpdatedTime).getTime();
        const currentTimeInMS = Date.now();
        diffInDuration = (currentTimeInMS - lastUpdateTimeInMS) / 1000;
    }
    return {
        sesd: diffInDuration,
    };
}
